import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import initRouter from "./router";
import PlayServerClient, {NotAuthenticated} from "./modules/PlayServerClient";
import {initVuex} from "./store";
import {NativeApi, NativeBridge} from "@/modules/NativeBridge";
import {MockNativeBridge} from "@/modules/MockNativeBridge";
import {redirect} from "@/modules/utils";
import rd from "@/modules/vRoutedefs";

Vue.config.productionTip = false;

function activeOrgnumFromQuery(): number | null {
    const matches = window.location.search.match(/[?&]orgnum=(\d{9})/);
    const orgnum = Number(matches && matches[1] ? matches[1] : 0);
    return orgnum > 0 ? orgnum : null;
}

/** Hide the loading graphics, display the gui html */
function showGui() {
    const loading = document.getElementById("loading");
    if(loading) loading.remove();
}

const api = new PlayServerClient();
const orgnum = activeOrgnumFromQuery() || 0;
const nativeBridge: NativeApi = process.env.VUE_APP_MOCK_NATIVE_BRIDGE == "true" ? new MockNativeBridge() : new NativeBridge(window);
const vuex = initVuex(api, orgnum, nativeBridge);

// Global js in index.html
declare function errorHandler(err: any);

// Load the minimum required state before initializing framework.
vuex.doneLoading.then(() => {
    const vueRouter = initRouter(vuex.baseApi);
    new Vue({
        router: vueRouter,
        store: vuex.store,
        provide: {
            "api": api,
            "baseApi": vuex.baseApi,
            "geoApi": vuex.geoApi,
            "nativeApi": nativeBridge,
        },
        render: h => h(App)
    }).$mount('#app')
}).catch((err) => {
    if(err instanceof NotAuthenticated) {
        // User not logged in (before router is initialized). Redirect to front page for login
        console.info("Not authenticated. Redirect to login page.");
        redirect(rd.public.path);

    } else {
        // Display error message, asking user to reload
        errorHandler(err);
        // TODO: Report error to server
        throw err;
    }
});
